import { EnvironmentInjector, Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';

import { Store } from '@ngrx/store';
import { CollectionNames } from '@vmspdb/definitions';
import { GlobalErrorHandlerService } from '@vmspdb/ui/common';
import { AuthRunEffects, selectAuthUserId } from '@vmspdb/ui/store';
import { concatMap, map } from 'rxjs/operators';
import {
  TimeTrackingRepositoryService,
  withSearchSync,
} from '../../repositories';
import * as TimeTrackingsActions from './time-tracking.actions';

@Injectable()
export class TimeTrackingEffects extends AuthRunEffects {
  private repository = inject(TimeTrackingRepositoryService);
  private store = inject(Store);
  private errors = inject(GlobalErrorHandlerService);
  private injector = inject(EnvironmentInjector);

  fetchMyTimeTracking$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TimeTrackingsActions.fetchMyTimeTracking),
      concatLatestFrom(() => this.store.select(selectAuthUserId)),
      withSearchSync(CollectionNames.TimeTracking, this.injector),
      concatMap(([, employeeUuid]) => this.repository.inProgress(employeeUuid)),
      map((result) =>
        TimeTrackingsActions.loadMyTimeTracking({ mine: result?.record }),
      ),
    );
  });

  deleteTimeTracking$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(TimeTrackingsActions.deleteTimeTracking),
        concatMap(({ item }) => this.repository.delete(item.uuid || '')),
      );
    },
    { dispatch: false },
  );

  constructor() {
    const actions$ = inject(Actions);

    super(actions$);
  }
}
